import { useCallback, useEffect, useState } from 'react';
import { socialApi, Veroeffentlichungsprofil, ProfilPlattform, ProfilStatus } from '../services/api';

/** Kurzer Zusatz hinter dem Namen in Auswahllisten. */
export const PROFIL_STATUS_ZUSATZ: Record<ProfilStatus, string> = {
  aktiv: '',
  laeuftAb: ' – läuft bald ab',
  abgelaufen: ' – abgelaufen',
  getrennt: ' – getrennt',
};

/** Text fuer eine Option: Name plus Zustand. */
export const profilOption = (p: Veroeffentlichungsprofil) => `${p.anzeigeName}${PROFIL_STATUS_ZUSATZ[p.status] ?? ''}`;

/**
 * Veroeffentlichungsprofile des Mandanten (GET /social/profile): Firmen-
 * konten und die persoenlichen Profile der Personen, die sie unter „Mein
 * Profil verbinden“ verbunden haben. Laedt einmal; ohne Recht oder bei
 * Fehlern bleibt die Liste leer (dann gilt das bisherige Verhalten).
 */
export function useVeroeffentlichungsprofile(aktiv = true) {
  const [profile, setProfile] = useState<Veroeffentlichungsprofil[]>([]);
  const [darfTeamprofile, setDarfTeamprofile] = useState(false);
  const [geladen, setGeladen] = useState(false);

  const laden = useCallback(async () => {
    try {
      const r = await socialApi.getProfile();
      setProfile(Array.isArray(r?.profile) ? r.profile : []);
      setDarfTeamprofile(!!r?.darfTeamprofile);
    } catch {
      setProfile([]);
    } finally {
      setGeladen(true);
    }
  }, []);

  useEffect(() => {
    if (aktiv) laden();
  }, [aktiv, laden]);

  /** Waehlbare Profile einer Plattform (ohne getrennte). */
  const fuer = useCallback(
    (plattform: ProfilPlattform) => profile.filter((p) => p.plattform === plattform && p.status !== 'getrennt'),
    [profile],
  );

  /** Profil zu einer Id (auch fuer die Anzeige am Eintrag). */
  const finden = useCallback((id: string | null | undefined) => (id ? profile.find((p) => p.id === id) ?? null : null), [profile]);

  return { profile, darfTeamprofile, geladen, fuer, finden, neuLaden: laden };
}
